import { useEffect, useState } from "react";
import { Gift, Copy, Share2 } from "lucide-react";
import { toast } from "sonner";

const money = (c) => `$${(c / 100).toFixed(2).replace(/\.00$/, "")}`;

export default function ReferralCard({ api }) {
  const [r, setR] = useState(null);
  useEffect(() => {
    api.get("/referral/me").then(({ data }) => setR(data)).catch(() => {});
  }, [api]);
  if (!r) return null;
  const link = `${window.location.origin}/?ref=${r.code}`;
  const copy = async (text, what) => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success(`${what} copied`);
    } catch {
      toast.error("Could not copy. Select and copy it manually.");
    }
  };
  const share = async () => {
    if (navigator.share) {
      try { await navigator.share({ title: "CarrierLaunch", text: `Use my code ${r.code} for ${r.discount_pct}% off CarrierLaunch`, url: link }); } catch { /* cancelled */ }
    } else copy(link, "Link");
  };
  const btn = "min-h-[40px] px-3 border border-[#262626] hover:border-white font-mono-label text-[11px] inline-flex items-center justify-center gap-1.5 transition-colors";
  return (
    <section className="brutal-border p-5 sm:p-6 mb-10" data-testid="referral-card">
      <div className="flex flex-col lg:flex-row lg:items-center gap-5 lg:justify-between">
        <div className="min-w-0">
          <div className="font-mono-label text-[10px] text-muted-foreground inline-flex items-center gap-1.5"><Gift size={12} className="text-[#FFD600]" /> REFER & SAVE</div>
          <div className="font-heading font-bold text-lg mt-1">Give {r.discount_pct}% off, get {money(r.reward_cents)} credit</div>
          <p className="text-sm text-muted-foreground mt-1 max-w-xl">
            Carriers who use your code get {r.discount_pct}% off every renewal of a 3-month, 6-month or annual plan. You get {money(r.reward_cents)} off your next billing period for each one who pays.
          </p>
          <div className="mt-3 flex flex-wrap gap-x-6 gap-y-1 text-sm" data-testid="referral-stats">
            <span><b data-testid="referral-paid-count">{r.paid_referrals}</b> paying referral{r.paid_referrals === 1 ? "" : "s"}</span>
            <span><b data-testid="referral-earned">{money(r.earned_cents)}</b> earned</span>
            {r.pending_credit_cents > 0 && <span className="text-[#FFD600]" data-testid="referral-pending">{money(r.pending_credit_cents)} credit will apply to your next payment</span>}
          </div>
        </div>
        <div className="shrink-0 w-full lg:w-auto">
          <div className="font-heading font-black text-3xl tracking-widest text-[#FFD600] mb-2" data-testid="referral-code">{r.code}</div>
          <div className="grid grid-cols-3 gap-2">
            <button onClick={() => copy(r.code, "Code")} className={btn} data-testid="referral-copy-code"><Copy size={12} /> Code</button>
            <button onClick={() => copy(link, "Link")} className={btn} data-testid="referral-copy-link"><Copy size={12} /> Link</button>
            <button onClick={share} className={btn} data-testid="referral-share"><Share2 size={12} /> Share</button>
          </div>
        </div>
      </div>
    </section>
  );
}
